export enum ActionTypes {
    FETCH_ORGANISATIONS = 'organisations-module/fetch-organisations',
    CREATE_ORGANISATION = 'organisations-module/create-organisation',
    UPDATE_ORGANISATION = 'organisations-module/update-organisation',
    DELETE_ORGANISATION = 'organisations-module/delete-organisation',
    JOIN_ORGANISATION = 'organisations-module/join-organisation',
}
